import { InvalidUserIdError, OperationAbortedError, throwApiError } from 'src/packages/errors';

import type { TUserSettings } from './user-settings-service';
import type { UserInfo } from '../auth-service/user-service';
import type { AxiosInstance } from 'axios';

interface IUserService {
  getUserData(): UserInfo | null;
}

export class UserSettingsServiceApi {
  private readonly agent: AxiosInstance;
  private readonly userService: IUserService;

  constructor(agent: AxiosInstance, userService: IUserService) {
    this.agent = agent;
    this.userService = userService;
  }

  private getUserId(): string {
    const sub = this.userService.getUserData()?.sub;

    if (!sub) {
      throw new InvalidUserIdError();
    }

    return sub;
  }

  async loadSettings(signal?: AbortSignal): Promise<TUserSettings> {
    try {
      const { data } = await this.agent.get('userSettings/user', {
        signal,
      });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async updateSettings(newSettings: TUserSettings, signal?: AbortSignal): Promise<void> {
    try {
      await this.agent.patch('userSettings/user', newSettings, { signal });
    } catch (e) {
      if (e instanceof OperationAbortedError) {
        return;
      }

      throwApiError(e);
    }
  }

  async createSettings(): Promise<{ id: number }> {
    const sub = this.getUserId();

    try {
      const { data } = await this.agent.post('userSettings/user', { ownerUserId: sub, settings: {} });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }
}
